import type { MagentoApiGetCustomerOrdersAllStoresQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../../magentoApiSlice/common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCustomerOrderAllStore = (builder: MagentoApiBuilder) => ({
  getCustomerOrdersAllStores: builder.query<MagentoApiGetCustomerOrdersAllStoresQueryResponse, void>({
    query: () => ({
      method: "getCustomerOrdersAllStores",
      params: [{}, { Store: "default" }],
    }),
    providesTags: [TAGS.CUSTOMER_ORDERS_ALL_STORES],
  }),
});
